import z from "zod";

export const createAudioTranscriptSchema = (isOptional: boolean) =>
  z.object({
    content: isOptional
      ? z.string().optional()
      : z.string().min(1, "Content is required"),
  });

export type AudioTranscriptFormData = {
  content?: string;
};
